import gql from "graphql-tag";

const enableSMSMutation = gql`
    mutation enableSMSmutation(
        $newMessageNotifications: [String]
        $phoneNumber: String
        $email: String
        $chatGroupId: String
        $applicant: String
        $mobileAdded: Boolean
        $dismissed: Boolean
    ) {
        updateApplicantPreferences(newMessageNotifications: $newMessageNotifications) {
            me {
                applicant {
                    preferences {
                        newMessageNotifications
                    }
                }
            }
        }
        updateApplicant(phoneNumber: $phoneNumber, email: $email) {
            me {
                anyUser {
                    id
                    email
                }
                applicant {
                    id
                    phoneNumber
                    preferences {
                        newMessageNotifications
                    }
                }
            }
            error
        }
        setWillReply(
            chatGroupId: $chatGroupId
            applicant: $applicant
            mobileAdded: $mobileAdded
            dismissed: $dismissed
        ) {
            chatGroupAux {
                willReply {
                    dismissed
                    mobileAdded
                    created
                }
            }
        }
    }
`;

export default enableSMSMutation;
